import { z } from 'zod';
export const AppPlatform = z.enum(['microsite', 'veeva']);
